import { PostHogProvider as PHProvider } from '@posthog/react';
import posthog from 'posthog-js';
import { FC, PropsWithChildren } from 'react';

const isProd = import.meta.env.PROD;
const apiUrl = import.meta.env.VITE_API_URL;
const phToken = import.meta.env.VITE_POSTHOG_TOKEN;
const phHost = import.meta.env.VITE_POSTHOG_HOST;

posthog.init(phToken, {
  // Proxy a través de nuestra API para evitar adblockers
  api_host: `${apiUrl}/posthog`,
  flags_api_host: `${apiUrl}/posthog-flags`,
  ui_host: phHost,
  person_profiles: 'identified_only',
  autocapture: false,
  capture_pageview: isProd,
  capture_pageleave: isProd,
  disable_session_recording: !isProd,
  loaded: ph => {
    if (!isProd) {
      ph.debug();
      ph.opt_out_capturing();
    }
  }
});

export const PostHogProvider: FC<PropsWithChildren> = ({ children }) => {
  return <PHProvider client={posthog}>{children}</PHProvider>;
};

export { posthog };
